import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { LoadingDots } from 'components/LoadingDots/LoadingDots';

export class Loader extends Component {
  state = { visible: false };

  componentDidMount() {
    this.timer = setTimeout(() => this.setState({ visible: true }), this.props.afterMs);
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  render() {
    // We only want to show loading dots when really slow internet
    // connection, otherwise just show an empty section item
    return (
      <ul>
        <li className="dropdown__item dropdown__item--loader">{this.state.visible && <LoadingDots />}</li>
      </ul>
    );
  }
}

Loader.defaultProps = {
  afterMs: 1500,
};

Loader.propTypes = {
  afterMs: PropTypes.number,
};
